'use client';
import styles from './myAccountMenu.module.scss';
import { Button, message, Switch } from 'antd';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import { AppContextActionKeyEnum, ThemeEnum } from 'types';
import { AppStorage, CopyToClipboard, RestAPI, useAsyncClick } from 'scripts';
import { API, PATH } from 'data';
import AppLinkComp from 'components/appLink/appLink.index';
import { COLORS } from 'utilities';
import { PiUserListDuotone } from 'react-icons/pi';
import { FaBookmark, FaShareAlt } from 'react-icons/fa';
import { MdOutlineHelp } from 'react-icons/md';
import { RiCustomerService2Fill } from 'react-icons/ri';
import { TbDownload } from 'react-icons/tb';
import { ImClock2 } from 'react-icons/im';
import { IoSunny } from 'react-icons/io5';
function MyAccountMenuComp({ className, setLogoutLoad }: { className?: string; setLogoutLoad: (e: boolean) => void }) {
    const { theme, update } = useContext(GlobalContext);
    const onThemeChange = () => {
        const newValue = theme === ThemeEnum.dark ? ThemeEnum.light : ThemeEnum.dark;
        update({ key: AppContextActionKeyEnum.theme, value: newValue });
        document.body.setAttribute('data-mode', newValue);
        RestAPI.post(API.middlewares.theme, { theme: newValue });
    };

    const onLogout = useAsyncClick(() => {
        return new Promise((resolve) => {
            setLogoutLoad(true);
            RestAPI.post(API.middlewares.logout, {})
                .then(() => {
                    update({ key: AppContextActionKeyEnum.profile, value: undefined });
                    AppStorage.authToken.remove();
                    message.success('خروج از حساب کاربری با موفقیت انجام شد.');
                })
                .catch(() => message.error('خطایی در خروج شما از حساب کاربری تان رخ داده است. لطفا بعدا تلاش کنید.'))
                .then(() => resolve(true))
                .finally(() => setLogoutLoad(false));
        });
    });

    const copyHandler = () => {
        CopyToClipboard(window.location.href);
        message.success('لینک سایت آقای شهر با موفقیت در کلیپ بوردتان ذخیر شد');
    };

    return (
        <div className={`${styles['menu-layout']} d-flex flex-column ${className}`}>
            <AppLinkComp href={PATH.panel.myAds()}>
                <div
                    className={`${styles['menu-item']} ${styles['menu-item-active']} center-content-y justify-content-between pointer`}
                >
                    <div className="d-flex center-content-y g-1">
                        <PiUserListDuotone size={20} color={COLORS.primary} />
                        <p className="t-p2 t-400 t-l-black1">آگهی های من</p>
                    </div>
                </div>
            </AppLinkComp>
            <AppLinkComp href={PATH.panel.views()}>
                <div
                    className={`${styles['menu-item']} ${styles['menu-item-active']} center-content-y justify-content-between pointer`}
                >
                    <div className="d-flex center-content-y g-1">
                        <ImClock2 size={20} color={COLORS.primary} />
                        <p className="t-p2 t-400 t-l-black1">بازدید های اخیر</p>
                    </div>
                </div>
            </AppLinkComp>
            <AppLinkComp href={PATH.panel.bookmarks()}>
                <div
                    className={`${styles['menu-item']} ${styles['menu-item-active']} center-content-y justify-content-between pointer`}
                >
                    <div className="d-flex center-content-y g-1">
                        <FaBookmark size={20} color={COLORS.primary} />
                        <p className="t-p2 t-400 t-l-black1">آگهی های نشان شده</p>
                    </div>
                </div>
            </AppLinkComp>
            <AppLinkComp href={PATH.aboutUs}>
                <div
                    className={`${styles['menu-item']} ${styles['menu-item-active']} center-content-y justify-content-between pointer`}
                >
                    <div className="d-flex center-content-y g-1">
                        <MdOutlineHelp size={20} color={COLORS.primary} />
                        <p className="t-p2 t-400 t-l-black1">درباره آقای شهر</p>
                    </div>
                </div>
            </AppLinkComp>
            <AppLinkComp href={PATH.panel.tickets.index()}>
                <div
                    className={`${styles['menu-item']} ${styles['menu-item-active']} center-content-y justify-content-between pointer`}
                >
                    <div className="d-flex center-content-y g-1">
                        <RiCustomerService2Fill size={20} color={COLORS.primary} />
                        <p className="t-p2 t-400 t-l-black1">پشتیبانی آقای شهر</p>
                    </div>
                </div>
            </AppLinkComp>
            <AppLinkComp href={PATH.download}>
                <div
                    className={`${styles['menu-item']} ${styles['menu-item-active']} bg-primary-i center-content-y justify-content-between pointer`}
                >
                    <div className="d-flex center-content-y g-1">
                        <TbDownload size={20} color={COLORS.white} />
                        <p className="t-p2 t-400 t-white-i">دریافت اپلیکیشن</p>
                    </div>
                </div>
            </AppLinkComp>
            <div
                className={`${styles['menu-item']} ${styles['menu-item-active']} center-content-y justify-content-between pointer pointer`}
            >
                <div className="d-flex center-content-y g-1">
                    <IoSunny size={20} color={COLORS.primary} />
                    <p className="t-p2 t-400 t-l-black1">{theme === ThemeEnum.light ? 'حالت شب' : 'حالت روز'}</p>
                </div>
                <Switch onChange={onThemeChange} value={theme === ThemeEnum.light ? true : false} />
            </div>
            <div
                onClick={copyHandler}
                className={`${styles['menu-item']} ${styles['menu-item-active']} center-content-y justify-content-between pointer`}
            >
                <div className="d-flex center-content-y g-1">
                    <FaShareAlt size={20} color={COLORS.primary} />
                    <p className="t-p2 t-400 t-l-black1">اشتراک گذاری آقای شهر</p>
                </div>
            </div>
            <Button {...onLogout} type="dashed">
                <p className="t-p3 t-400 t-d-white-i t-l-black1-i">خروج از حساب کاربری</p>
            </Button>
        </div>
    );
}

export default MyAccountMenuComp;
